<template>
  <v-snackbar
    v-model="isCookiesBarEnabled"
    :auto-height="true"
    :multi-line="true"
    :top="true"
    :timeout="0"
  >
    <span>This site uses
      <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noreferrer">cookies</a>
      from Google to deliver its services and analyze traffic. Your IP address and user-agent are
    shared with Google along with performance and security metrics to ensure quality of service, generate usage
    statistics, and to detect and address abuse.</span>
    <v-btn
      color="blue"
      flat
      @click="onAcceptCookies"
    >
      OK
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'CookiesBar',
  props: {
    isCookiesBarEnabled: Boolean,
    onAcceptCookies: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CookiesBar.vue